// extracted by mini-css-extract-plugin
export var fullWidthButton = "_pu-0";